import format from 'date-fns/format'
import ruLocale from 'date-fns/locale/ru'

const getUppercaseMonth = (date: Date) => {
  const month = format(date, 'LLLL', {
    locale: ruLocale
  })

  return month[0].toUpperCase() + month.slice(1)
}

export const getFormattedDate = (date: Date) => {
  const month = getUppercaseMonth(date)

  const year = format(date, ', yyyy г.', {
    locale: ruLocale
  })

  return month + year
}

export const getFormattedCalendarDate = (date: Date) => {
  const month = getUppercaseMonth(date)

  const year = format(date, ' yy', {
    locale: ruLocale
  })

  return month + year
}
